export const checkIsAdmin = function (user) {
  var isAdmin = false;
  if (user.is_admin === true) {
    isAdmin = true;
  }
  return isAdmin;
};

export const checkIsActive = function (status) {
  var isActive = false;
  if (status === "active") {
    isActive = true;
  }
  return isActive;
};

export const checkIsEmailVerified = function (email_verified) {
  var isEmailVerified = false;
  if (email_verified === true) {
    isEmailVerified = true;
  }
  return isEmailVerified;
};
